export * from './tab.component';
